enum DatePickerLocale {
  PL = "pl",
  DE = "de",
  EN = "en",
}

export default DatePickerLocale;
